import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { History } from "history";
import settingsReducer from "./Settings";
import commonReducer from "./Common";

const createRootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    settings: settingsReducer,
    common: commonReducer
  });

export default createRootReducer;
